import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('buying-options', storeModule.createStoreModule('buying-options'))
